// App - main application component with routing
// Implements US-0.2: Frontend Design System and Proto Pages
// Implements US-2.2: Join Workspace with Role Assignment

import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import GuestAccess from './pages/GuestAccess';
import WorkspaceList from './pages/WorkspaceList';
import JoinWorkspace from './pages/JoinWorkspace';
import WorkspaceDetail from './pages/WorkspaceDetail';
import NotFound from './pages/NotFound';
import { initializeCsrfToken } from './utils/apiClient';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RootRedirect } from './components/RootRedirect';
import './App.css';

/**
 * RENDER main application with routing
 * NOTE: Each page uses Layout component independently for elevated card pattern
 */
function App() {
  // INITIALIZE CSRF token on app load
  useEffect(() => {
    initializeCsrfToken();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* REDIRECT root to workspace list (but wait if SSO token present) */}
          <Route path="/" element={<RootRedirect />} />

          {/* LOGIN page for authenticated users */}
          <Route path="/login" element={<Login />} />

          {/* GUEST ACCESS page for viewers */}
          <Route path="/guest" element={<GuestAccess />} />

          {/* WORKSPACE LIST page for authenticated users - PROTECTED */}
          <Route path="/workspaces" element={
            <ProtectedRoute>
              <WorkspaceList />
            </ProtectedRoute>
          } />

          {/* JOIN WORKSPACE page via room code */}
          <Route path="/join" element={<JoinWorkspace />} />

          {/* WORKSPACE DETAIL page - allows both authenticated users and viewers */}
          <Route path="/workspaces/:id" element={<WorkspaceDetail />} />

          {/* 404 NOT FOUND for unknown routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
